import { render, staticRenderFns } from "./ManageIntegration.vue?vue&type=template&id=5c052db0"
import script from "./ManageIntegration.vue?vue&type=script&lang=js"
export * from "./ManageIntegration.vue?vue&type=script&lang=js"
import style0 from "./ManageIntegration.vue?vue&type=style&index=0&id=5c052db0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports